module.exports = __webpack_public_path__ + "img/cgl_insurance_required.23450aed.svg";